import * as z from "zod";

export const updateExchangeOrderCreationFunction = {
  name: "updateExchangeOrderCreationFunction" as const,
  input: z.object({ artifactId: z.string().optional() }),
  output: z.object({}),
};
